import { environment } from '../../../../environments/environment';

// Validate account name availability
export function AccountNameAvailableValidator($q, $http) {
  return {
    require: 'ngModel',
    link: function (scope, element, attrs, ngModel) {
      ngModel.$asyncValidators.accounNameAvailable = function (modelValue) {
        if (modelValue !== attrs.accountNameAvailableValidator) {
          return $http.get(environment.apiEndpoint + 'sessions/check_account_name?q=' + modelValue);
        }

        return $q.resolve(true);
      };
    },
  };
}

AccountNameAvailableValidator.$inject = ['$q', '$http'];
